import { render, staticRenderFns } from "./CMobileTable.vue?vue&type=template&id=fdb70ad2&scoped=true"
import script from "./CMobileTable.vue?vue&type=script&lang=js"
export * from "./CMobileTable.vue?vue&type=script&lang=js"
import style0 from "./CMobileTable.vue?vue&type=style&index=0&id=fdb70ad2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb70ad2",
  null
  
)

export default component.exports